import React, { useRef, useState } from 'react';
import { colors } from '../../constants/colors';
import { exportWebAnalyticsReport } from '../../services/(adminapi)/webAnalyticsAPI';

const ExportReportsButton = ({ days, disabled = false }) => {
  const [open, setOpen] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);
  const menuRef = useRef(null);

  const handleExport = async (format) => {
    setOpen(false);
    setExporting(true);
    setError(null);
    try {
      await exportWebAnalyticsReport(format, { days });
    } catch (err) {
      console.error('Export failed:', err);
      setError(err.message || 'Export failed');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div style={{ position: 'relative' }} ref={menuRef}>
      <button
        type="button"
        disabled={disabled || exporting}
        onClick={() => {
          if (exporting) return;
          setOpen((v) => !v);
        }}
        style={{
          padding: '8px 14px',
          fontSize: '14px',
          border: `1px solid #E5E7EB`,
          borderRadius: '10px',
          backgroundColor: colors.background.primary,
          color: colors.text.primary,
          cursor: disabled || exporting ? 'not-allowed' : 'pointer',
          fontWeight: 600,
          opacity: disabled ? 0.6 : 1,
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        }}
      >
        {exporting ? 'Exporting...' : 'Export ▼'}
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            minWidth: 160,
            backgroundColor: colors.background.primary,
            border: `1px solid ${colors.borderVariants.light}`,
            borderRadius: '8px',
            boxShadow: '0 10px 30px rgba(15, 23, 42, 0.12)',
            zIndex: 50,
            overflow: 'hidden',
          }}
        >
          {[
            { format: 'csv', label: 'CSV' },
            { format: 'xlsx', label: 'Excel (.xlsx)' },
            { format: 'pdf', label: 'PDF' },
          ].map((item) => (
            <button
              key={item.format}
              type="button"
              disabled={exporting}
              onClick={() => handleExport(item.format)}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                padding: '10px 14px',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontSize: '14px',
                color: colors.text.primary,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = colors.background.secondary;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}

      {error ? (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 6px)',
            right: 0,
            marginTop: open ? 140 : 0,
            fontSize: 12,
            color: colors.status.error,
            whiteSpace: 'nowrap',
          }}
        >
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default ExportReportsButton;
